import { render } from "./titleComp.vue?vue&type=template&id=1a6505aa&scoped=true&ts=true"
import script from "./titleComp.vue?vue&type=script&lang=ts"
export * from "./titleComp.vue?vue&type=script&lang=ts"

import "./titleComp.vue?vue&type=style&index=0&id=1a6505aa&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6505aa"]])

export default __exports__